/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/EditorDialogBase.ts" />
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class TargetMasterDialog extends Common.GridEditorDialog<TargetMasterRow> {
        protected getFormKey() { return TargetMasterForm.formKey; }
        //protected getIdProperty() { return TargetMasterRow.idProperty; }
        protected getLocalTextPrefix() { return TargetMasterRow.localTextPrefix; }
        //protected getService() { return TargetMasterService.baseUrl; }

        protected form = new TargetMasterForm(this.idPrefix);
        constructor() {
            super();
            //q.setTextRightAlign(this.form.Pieces);
            //q.setTextRightAlign(this.form.Weight);
            //q.setTextRightAlign(this.form.Target);
        }
    }
}